import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Comment\AddCommentToModelController::__invoke
* @see app/Http/Controllers/Comment/AddCommentToModelController.php
* @route '/api/comment/comment/{id}'
*/
const AddCommentToModelController313bf0d7bf4ac62e30dcb2a851a2cc98 = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: AddCommentToModelController313bf0d7bf4ac62e30dcb2a851a2cc98.url(args, options),
    method: 'put',
})

AddCommentToModelController313bf0d7bf4ac62e30dcb2a851a2cc98.definition = {
    methods: ["put"],
    url: '/api/comment/comment/{id}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Comment\AddCommentToModelController::__invoke
* @see app/Http/Controllers/Comment/AddCommentToModelController.php
* @route '/api/comment/comment/{id}'
*/
AddCommentToModelController313bf0d7bf4ac62e30dcb2a851a2cc98.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return AddCommentToModelController313bf0d7bf4ac62e30dcb2a851a2cc98.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Comment\AddCommentToModelController::__invoke
* @see app/Http/Controllers/Comment/AddCommentToModelController.php
* @route '/api/comment/comment/{id}'
*/
AddCommentToModelController313bf0d7bf4ac62e30dcb2a851a2cc98.put = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: AddCommentToModelController313bf0d7bf4ac62e30dcb2a851a2cc98.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Comment\AddCommentToModelController::__invoke
* @see app/Http/Controllers/Comment/AddCommentToModelController.php
* @route '/api/task-dossier/comment/{id}'
*/
const AddCommentToModelController34aad93e6e88659bf97ad1fc249ad862 = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: AddCommentToModelController34aad93e6e88659bf97ad1fc249ad862.url(args, options),
    method: 'put',
})

AddCommentToModelController34aad93e6e88659bf97ad1fc249ad862.definition = {
    methods: ["put"],
    url: '/api/task-dossier/comment/{id}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Comment\AddCommentToModelController::__invoke
* @see app/Http/Controllers/Comment/AddCommentToModelController.php
* @route '/api/task-dossier/comment/{id}'
*/
AddCommentToModelController34aad93e6e88659bf97ad1fc249ad862.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return AddCommentToModelController34aad93e6e88659bf97ad1fc249ad862.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Comment\AddCommentToModelController::__invoke
* @see app/Http/Controllers/Comment/AddCommentToModelController.php
* @route '/api/task-dossier/comment/{id}'
*/
AddCommentToModelController34aad93e6e88659bf97ad1fc249ad862.put = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: AddCommentToModelController34aad93e6e88659bf97ad1fc249ad862.url(args, options),
    method: 'put',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Comment\AddCommentToModelController::AddCommentToModelController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `AddCommentToModelController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const AddCommentToModelController = {
    '/api/comment/comment/{id}': AddCommentToModelController313bf0d7bf4ac62e30dcb2a851a2cc98,
    '/api/task-dossier/comment/{id}': AddCommentToModelController34aad93e6e88659bf97ad1fc249ad862,
}

export default AddCommentToModelController